@use '../../../../styles/scss/vcom/mixins/breakpoints';
@use '../../../../styles/scss/global/variables/commonConfigs' as commonConfigs;

$content-bundle-radius: 30px;

vs-content-bundle {
  width: 100%;
}

.vs-content-bundle {
  max-width: calc(100% - 4px);
  margin: 2px auto 30px auto;

  &[data-layout='content-library'] {
    padding-left: 15px;
    padding-right: 15px;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    max-width: 540px;

    @include breakpoints.tablet-up {
      max-width: 720px;
    }

    @include breakpoints.desktop-up {
      max-width: calc(0.33 * 960px);
      margin-left: 12%;
      margin-right: 12%;
    }

    @include breakpoints.desktop-plus-up {
      max-width: calc(0.33 * 1140px);
    }
  }

  &[data-view-publish-date='no'] {
    .vs-content-bundle-date {
      display: none;
    }
  }

  .vs-content-bundle-media {
    position: relative;
    display: block;
    max-width: 100%;
    overflow: hidden;
    margin-bottom: 20px;
    text-align: center;
    border-radius: $content-bundle-radius;

    &[data-video='yes'] img {
      transition: transform 0.35s ease-in-out;
    }

    &[data-video='yes']:hover {
      & img {
        transform: scale(1.05);
        cursor: pointer;
      }
    }

    &:hover {
      & button {
        opacity: 0.9;
      }
    }

    & button:focus {
      opacity: 0.9;
    }
  }

  .vs-content-bundle-img {
    display: block;
    max-width: 100%;
    width: 100%;
    height: auto;
  }

  .vs-content-bundle-text {
    position: relative;
    margin-bottom: 20px;

    & .vs-content-bundle-date,
    & .vs-content-bundle-header,
    & .vs-content-bundle-body,
    & .vs-content-bundle-body p {
      margin-bottom: 10px;
    }

    & p:not(.vs-lead):not(.vs-meta):not(.vs-legal) {
      margin-bottom: 10px;
      color: #2c2c2c;
      font-family: var(--text-font-family), sans-serif;
      font-size: 17px;
      font-weight: 100;
      line-height: 22px;
    }

    &.vs-content-bundle-body {
      margin-bottom: 20px;
    }
  }

  .vs-content-bundle-cta {
    position: relative;

    & a {

      &.vs-link-cta,
      &.vs-btn {
        margin-bottom: 20px;
      }

      &.vs-link-cta {
        width: fit-content;
      }
    }
  }
}
